module.exports = __webpack_public_path__ + "img/star_product_3.6ba36d8e.png";